import axios from "axios";
import { BaseURL } from "./url";

//Auth
export const updatePassword = async (datas) => {
  return axios.patch(`${BaseURL}/users/${datas?.user_id}/new-password`, datas);
};
export const updateProfile = async (datas) => {
  return axios.patch(`${BaseURL}/users/${datas?.user_id}`, datas);
};
export const registerUser = async (formData) => {
  return axios.post(`${BaseURL}/users`, formData);
};
export const loginUser = async (data) => {
  return axios.post(`${BaseURL}/auth/login`, data);
};
export const forgotPass = async (data) => {
  return axios.post(`${BaseURL}/auth/forgot-password`, data);
};
export const getTokenEmail = async () => {
  return axios.get(`${BaseURL}/get-token-email`);
};
export const getListingAdmin = async () => {
  return axios.get(`${BaseURL}/listing/admin/summary`);
};
export const getAdminDashboard = async () => {
  return axios.get(`${BaseURL}/listing/admin/summary`);
};
export const searchLocation = async (data) => {
  return axios.get(`${BaseURL}/listing/search?query=${data}`);
};
export const listingRecommended = async () => {
  return axios.get(`${BaseURL}/listing/recommended`);
};
export const getAdminListing = async (data) => {
  return axios.get(
    `${BaseURL}/admin/listings?page=${data?.currentPage}&pageSize=${data?.itemsPerPage}&sortBy=${data?.sort}&rent=${data?.rent}&lease=${data?.lease}&buy=${data?.buy}&shortlet=${data?.shortlet}&status=${data?.status}`
  );
};
export const getAdminListingUser = async (data) => {
  return axios.get(
    `${BaseURL}/listing/user?page=${data?.currentPage}&pageSize=${data?.itemsPerPage}&sortBy=${data?.sort}&rent=${data?.rent}&lease=${data?.lease}&buy=${data?.buy}&shortlet=${data?.shortlet}&status=${data?.status}`
  );
};
export const getOffersUser = async (data) => {
  return axios.get(
    `${BaseURL}/offers/user?page=${data?.currentPage}&pageSize=${data?.itemsPerPage}&sortBy=${data?.sort}`
  );
};
export const getUserDetails = async (data) => {
  return axios.get(`${BaseURL}/offer`);
};
export const getUserSellOffers = async (data) => {
  return axios.get(
    `${BaseURL}/offers/user/inflow?page=${data?.currentPage}&pageSize=${data?.itemsPerPage}&sortBy=${data?.sort}`
  );
};
export const getNotifcations = async (data) => {
  return axios.get(`${BaseURL}/notification/${data}`);
};
export const getAdminOffersView = async (data) => {
  return axios.get(
    `${BaseURL}/offers/admin?page=${data?.currentPage}&pageSize=${data?.itemsPerPage}&sortBy=${data?.sort}`
  );
};
export const getTransation = async (data) => {
  return axios.get(
    `${BaseURL}/transaction?page=${data?.currentPage}&pageSize=${data?.itemsPerPage}&sortBy=${data?.sort}`
  );
};
export const getAdminTransation = async (data) => {
  return axios.get(
    `${BaseURL}/admin/transaction?page=${data?.currentPage}&pageSize=${data?.itemsPerPage}&sortBy=${data?.sort}`
  );
};
export const getListing = async (data) => {
  return axios.get(
    `${BaseURL}/listing?page=${data?.currentPage}&pageSize=${data?.itemsPerPage}&sortBy=${data?.sort}&rent=${data?.rent}&lease=${data?.lease}&buy=${data?.buy}&shortlet=${data?.shortlet}&minPrice=${data?.min}&maxPrice=${data?.max}&bed=${data?.bed}&bath=${data?.bath}&propertyType=${data?.propertyType}&furnishing=${data?.furnished}&electric_power=${data?.light}&security=${data?.security}&snooker=${data?.snooker}&swimming_pool=${data?.pool}&oceanview=${data?.ocean}&gym=${data?.gym}&washer=${data?.washer}&wifi=${data?.wifi}&location=${data?.location}`
  );
};
// export const getListing = async (data) => {
//   return axios.get(
//     `${BaseURL}/listing?page=${data?.currentPage}&pageSize=${data?.itemsPerPage}&sortBy=${data?.sort}&rent=${data?.rent}&lease=${data?.lease}&buy=${data?.buy}&shortlet=${data?.shortlet}&minPrice=${data?.min}&maxPrice=${data?.max}&bed=${data?.bed}&bath=${data?.bath}&propertyType=${data?.propertyType}&furnishing=${data?.furnishing}&location=${data?.location}`
//   );
// };

export const generateRequestCode = async (data) => {
  return axios.post(`${BaseURL}/resend-token/${data}`);
};
export const veriflyeRequestCode = async (data) => {
  return axios.post(`${BaseURL}/auth/resend-token`);
};
export const changePassword = async (data) => {
  return axios.post(`${BaseURL}/auth/reset-password/${data?.token}`, data);
};
export const getEmail = async (data) => {
  return axios.get(`${BaseURL}/auth/${data}`);
};

// Main site
export const getFeaturedProperties = async () => {
  return axios.get(`${BaseURL}/featured-properties`);
};
export const getAllLocation = async (location) => {
  return axios.get(`${BaseURL}/get-location?location=${location}`);
};
export const getHomeSearch = async (allSearchFields) => {
  return axios.get(
    `${BaseURL}/search-homart?purpose=${allSearchFields?.purpose}&location=${allSearchFields?.location}&property_type=${allSearchFields?.property_type}&bed=${allSearchFields?.bed}`
  );
};
export const getPropertyDetails = async (id) => {
  return axios.get(`${BaseURL}/property-details/${id}`);
};
export const getListingPictures = async (id) => {
  return axios.get(`${BaseURL}/upload/${id}`);
};
export const getListingPictures2 = async (id) => {
  return axios.get(`${BaseURL}/upload/modified/${id}`);
};
export const makeOffers = async (data) => {
  return axios.post(`${BaseURL}/offers`, data);
};
export const uploadHost = async (formData) => {
  return axios.post(`${BaseURL}/upload/multiple`, formData);
};
export const updateUpload = async (data) => {
  return axios.patch(`${BaseURL}/upload/multiple/${data?.id}`, data?.data);
};
export const deleteHostPic = async (data) => {
  return axios.post(`${BaseURL}/upload/${data?.uploadId}/delete`, data);
};

//Admin
export const uploadListing = async (data) => {
  return axios.post(`${BaseURL}/listing`, data);
};
export const uploadWhshList = async (data) => {
  return axios.post(`${BaseURL}/mailing-list/subscribe`, data);
};
export const confirmPayment = async (data) => {
  return axios.post(
    `${BaseURL}/payments/${data?.provider}/verify?reference=${data?.reference}&trxref=${data?.trxref}`,
    data
  );
};
export const confirmEmail = async (data) => {
  return axios.post(`${BaseURL}/users/verify-email?token=${data}`);
};
export const confirmPaymentAdmin = async (data) => {
  return axios.patch(`${BaseURL}/admin/transaction/authorize-offline/${data}`);
};
export const makePayment = async (data) => {
  return axios.post(
    `${BaseURL}/payments/${data?.provider}/initiate/${data?.referenceId}`,
    data
  );
};

export const getListingRequests = async () => {
  return axios.get(`${BaseURL}/listing-requests`);
};
export const getListingDetails = async (id) => {
  return axios.get(`${BaseURL}/listing/${id}`);
};
export const getOffersDetails = async (id) => {
  return axios.get(`${BaseURL}/offers/${id}`);
};
export const approveListing = async (data) => {
  return axios.patch(`${BaseURL}/admin/listing/approve/${data?.id}`);
};
export const updateListing = async (data) => {
  return axios.patch(`${BaseURL}/listing/${data?.listingId}`, data);
};
export const approveOffer = async (data) => {
  return axios.patch(
    `${BaseURL}/offers/admin/${data?.offerId}/verify-documents/${data?.uploadId}?action=${data?.action}`,
    data
  );
};
export const docUploadOffer = async (data) => {
  return axios.patch(`${BaseURL}/offers/${data?.id}/upload`, data?.data);
};
export const docUploadRecipt = async (data) => {
  return axios.post(
    `${BaseURL}/transaction/${data?.id}/upload-receipt`,
    data?.data
  );
};

export const declineOffer = async (data) => {
  return axios.patch(`${BaseURL}/offers/${data}/reject`);
};
export const counterAdminOffer = async (data) => {
  return axios.patch(`${BaseURL}/offers/admin/${data?.id}/counter-offer`, data);
};
export const preApproveAdminOffer = async (data) => {
  return axios.patch(`${BaseURL}/offers/admin/${data}/pre-approve`);
};
export const declineListing = async (data) => {
  return axios.patch(`${BaseURL}/admin/listing/reject/${data?.id}`, data);
};
